module.exports = __webpack_public_path__ + "static/media/Dragona.e73c7127.png";